import {VanillaVoidCallback} from '../VanillaReader/VanillaReaderModel';

/**
 * # VanillaReaderUiFabHighlight
 *
 * ## RESPONSIBILITIES
 *
 * ## RELATED TYPES
 * - VanillaReaderUiFabHighlightController
 *
 */
export class VanillaReaderUiFabSpeakText {
    private _template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-speaktext" type="button" title="Speak selected text" aria-hidden="true"><span class="vanilla-reader__fab__icon" aria-hidden="true">hearing</span></button>`;
    private _onClickCallback: VanillaVoidCallback | undefined;
    private _onVisibleCallback: VanillaVoidCallback | undefined;
    private _onHiddenCallback: VanillaVoidCallback | undefined;
    private _speakButton: HTMLButtonElement;
    private _speakButtonIcon: HTMLButtonElement;
    private _stateIsPlaying: boolean = false;

    constructor(private _hostElement: HTMLElement, insertPosition: InsertPosition = 'afterbegin') {
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._speakButton = this._hostElement.querySelector('#vanilla-reader__fab-speaktext')!;
        this._speakButtonIcon = this._hostElement.querySelector('#vanilla-reader__fab-speaktext > .vanilla-reader__fab__icon')!;
        this._speakButton.addEventListener('click', (_ev: MouseEvent) => {
            if (this._onClickCallback) {
                if (this.isVisible) {
                    this._onClickCallback();
                }
            }
        });
    }

    public get isVisible(): boolean {
        return !this._speakButton.hasAttribute('aria-hidden');
    }

    show(): void {
        this._speakButton.removeAttribute('aria-hidden');
        this._speakButton.setAttribute('accesskey', 'i');
        this._speakButton.style.display = 'flex';
        this._speakButton.style.opacity = '1';
        this._speakButton.style.pointerEvents = 'all';
        if (this._onVisibleCallback) {
            this._onVisibleCallback();
        }
    }

    hide(): void {
        this._speakButton.removeAttribute('accesskey');
        this._speakButton.setAttribute('aria-hidden', 'true');
        this._speakButton.style.opacity = '0';
        this._speakButton.style.pointerEvents = 'none';

        this.stateIsSpeaking = false;

        setTimeout(()=>{
            this._speakButton.style.display = 'none';
        },200);

        if (this._onHiddenCallback) {
            this._onHiddenCallback();
        }
    }

    public get stateIsSpeaking(): boolean {
        return this._stateIsPlaying;
    }

    public set stateIsSpeaking(isPlaying: boolean) {
        this._stateIsPlaying = isPlaying;
        if (isPlaying) {
            this._speakButtonIcon.innerText = 'stop';
        } else {
            this._speakButtonIcon.innerText = 'hearing';
        }
    }

    getComponentElement(): HTMLElement {
        return this._speakButton;
    }

    onClick(callback: VanillaVoidCallback): void {
        this._onClickCallback = callback;
    }

    onVisible(callback: VanillaVoidCallback): void {
        this._onVisibleCallback = callback;
    }

    onHidden(callback: VanillaVoidCallback): void {
        this._onHiddenCallback = callback;
    }

}
